export default "__VITE_ASSET__MCS3MUD9__"